import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-style-default',
  templateUrl: './layout-style-default.component.html'
})
export class LayoutStyleDefaultComponent {

  constructor() {
  }

}
